import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import ReactTable from 'react-table';
import Loading from '../../loading/Loading';
import ReportsDescription from '../reportsDescription/ReportsDescription';
import * as Consts from '../../../constants';
import './TableReport.css';
import './ReactTable.css';

const TableReport = ({
  columns, data = [], description = null, title, width,
}) => (

  <div className="TableReport report">

    <ReportsDescription title={t(title)}
      description={description}
      width={width - (width * Consts.REPORT_DESCRIPTION_WIDTH)}
    />

    <div className={data === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}>{! data ? <Loading size={40} />
      : data === t('unableToFetchData') ? t('unableToFetchData') : (
        <ReactTable className="-striped -highlight"
          columns={columns}
          data={data}
          showPagination={false}
          minRows={5}
          pageSize={data.length > Consts.DEFAULT_TABLE_ROWS ? Consts.DEFAULT_TABLE_ROWS : data.length}
        />
      )
    }</div>
  </div>
);
export default connect()(TableReport);
